import React from 'react';
import TinyTickets from 'views/tiny/TinyTickets.js';

function TinyTicketsContainer() {
  return <TinyTickets />;
}

export default TinyTicketsContainer;
